module.exports = __webpack_public_path__ + "img/ill_spot_info_tnc.37a39355.svg";